/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:a61d0bf3-ef8c-4cc2-95f5-d9d9a7936f2f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_15UdbenJ7",
    "aws_user_pools_web_client_id": "6sf34j4ul9er2c5gpmmrhdc8ca",
    "oauth": {
        "domain": "playground-experiment.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000,https://playground.brainqtech.com,https://playground-experiment.brainqtech.com",
        "redirectSignOut": "http://localhost:3000,https://playground.brainqtech.com,https://playground-experiment.brainqtech.com",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
